import barba from '@barba/core';
import gsap from 'gsap';

let animDuration = 0.5;

if (!!prefersReducedMotion) {
    animDuration = 0;
}

const $body = $('body');

function delay(n) {
    n = n || 2000;
    return new Promise((done) => {
        setTimeout(() => {
            done();
        }, n);
    });
}

function transitionPage() {
    const $transition = $('.page-transition'),
        $iconBars = $('.page-transition__icon .sprog-icon span'),
        $iconBarTop = $('.page-transition__icon .sprog-icon span:nth-child(1)'),
        $iconBarMiddle = $('.page-transition__icon .sprog-icon span:nth-child(2)');

    const tlIcon = gsap.timeline({
        delay: animDuration,
        repeat: -1,
        repeatDelay: animDuration * 0.5,
        repeatRefresh: true
    });

    const tlMain = gsap.timeline({
        onComplete: pageTransitionComplete
    });

    // create main transition animation
    tlMain.to($transition, {
        duration: animDuration * 2.5,
        width: '100%',
        right: 0,
        ease: 'Expo.easeInOut',
    })
    .to($transition, {
        duration: animDuration * 2,
        width: 0,
        right: '100%',
        ease: 'Expo.easeInOut',
        delay: animDuration,
    })
    .set($transition, {
        right: 0,
    });

    // prepare icon for animation
    gsap.set($iconBars, {
        top: 'auto',
        bottom: 0,
        transform: 'none'
    });

    // create icon animation
    tlIcon.to($iconBarTop, {
        duration: animDuration,
        delay: animDuration * 0.25,
        ease: 'power1.out',
        bottom: 'auto'
    })
    .to($iconBarMiddle, {
        duration: animDuration,
        ease: 'power1.out',
        bottom: '42.5%',
    }, '<')
    .fromTo($iconBarMiddle, {
        rotation: 0
    }, {
        duration: animDuration * 2,
        ease: 'power1.Out',
        rotation: 180,
    }, '<')
    .to($iconBarMiddle, {
        duration: animDuration,
        ease: 'power1.in',
        bottom: 0,
    }, '-='+animDuration)
    .to($iconBarTop, {
        duration: animDuration * 0.875,
        ease: 'power1.in',
        bottom: 0
    }, '<');

    function pageTransitionComplete() {
        $body.trigger('pageTransitionComplete');
        tlIcon.pause(0);
    }
}

if ($body.hasClass('logged-in')) {
    $body.trigger('initScripts');
} else {
    barba.init({
        sync: true,
        debug: false,
        timeout: 7000,
        preventRunning: true,
        transitions: [{
            async once(data) { // first load
                $body.trigger('initScripts');
            },
            async enter(data) { // new page loaded
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'instant'
                });

                $body.trigger('initScripts');
            },
            async leave(data) { // transition
                const done = this.async();

                transitionPage();
                await delay(animDuration * 2500);
                done();
            },
            async after(data) {
                // set proper body classes after transition - https://fjobeir.com/implement-barba-v2-with-wordpress/
                let parser = new DOMParser();
                let htmlDoc = parser.parseFromString(data.next.html.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', data.next.html), 'text/html');
                let bodyClasses = htmlDoc.querySelector('notbody').getAttribute('class');
                $body.attr('class', bodyClasses);
            },
            async afterEnter(data) {
                // Check if new page has Gravity Form
                const $formWrapper = jQuery(data.next.container).find('.gform_wrapper');

                if ($formWrapper.length > 0) {
                    // get form ID (for example 'gform_wrapper_5')
                    const formId = $formWrapper.attr('id').split('_').pop();

                    // reinit form
                    // the '1' represents the current page within the form
                    jQuery(document).trigger('gform_post_render', [formId, 1]);

                    // using conditional logic? Then you will often need this too:
                    if (window['gf_apply_rules']) {
                        gf_apply_rules(formId, [], true);
                    }
                }
            }
        }]
    });
}

/*
Als Gravity Forms specifieke inline <script> tags binnen de container plaatst, voert Barba deze standaard niet uit. Je kunt een helper-functie gebruiken die alle script-tags in de nieuwe container vindt en ze handmatig uitvoert:
function executeScripts(container) {
  const scripts = container.querySelectorAll('script');
  scripts.forEach(oldScript => {
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

// Aanroepen in afterEnter:
afterEnter(data) {
    executeScripts(data.next.container);
}

Gebruik je Google reCAPTCHA? Die is berucht in combinatie met Barba. Als die niet verschijnt, moet je de grecaptcha.render() functie specifiek aanroepen in de afterEnter hook.
*/
